import { Injectable, inject } from '@angular/core';
import { SharedUiThemingCssVariablesService } from '../shared-ui-theming-css-variables.service';
import { SharedUiGapsService } from './shared-ui-gaps.service';
import { SharedUiGapsName } from './shared-ui-gaps.types';

@Injectable({
    providedIn: 'root'
})
export class SharedUiGapsCssVariablesAutoUpdateService {
    private _themingCssVariablesService = inject(SharedUiThemingCssVariablesService);
    private _spacingService = inject(SharedUiGapsService);

    defineGapsCssVariablesAutoUpdate() {
        Object.values(SharedUiGapsName).forEach(value => {
            this._spacingService.getGap$(value as SharedUiGapsName).subscribe(gap => {
                this._themingCssVariablesService.setThemingCssVariable('spacing', value, gap);
            });
        });
    }
}
